import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * GA4Tracker - envoie un event `page_view` a chaque changement de route SPA.
 * gtag est chargé dans index.html (Consent Mode v2). Ce composant ne fait
 * que declencher les page_view manuels au bon moment.
 */
export function GA4Tracker() {
  const location = useLocation();

  useEffect(() => {
    if (typeof window === 'undefined' || typeof window.gtag !== 'function') return;
    const url = window.location.origin + location.pathname + location.search;
    window.gtag('event', 'page_view', {
      page_location: url,
      page_path: location.pathname + location.search,
      page_title: document.title,
    });
  }, [location.pathname, location.search]);

  return null;
}

/**
 * Helper util : envoie un event personnalisé a GA4.
 * Usage : trackEvent('phone_click', { source: 'header' })
 */
export function trackEvent(name, params = {}) {
  if (typeof window !== 'undefined' && typeof window.gtag === 'function') {
    window.gtag('event', name, params);
  }
}
